export function Spinner() {
  return <div className="spinner" aria-label="Carregando" />;
}

export function FullScreenSpinner() {
  return (
    <div className="center-screen">
      <Spinner />
    </div>
  );
}
